// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__23Dsb","content":"Footer_content__XYDNq","links":"Footer_links__kwgOr"};